<template>
  <div class="hua-box">
    <div class="box-head">
    <el-page-header @back="goBack" content=""></el-page-header>
    <span>预警时间：</span>
          <el-date-picker
      v-model="search.alarmDate"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期" style="margin-right:2vw;">
    </el-date-picker>
      <span>预警类型名称：</span>
      <el-input
        v-model="search.alarmEventName"
        placeholder="请输入"
        clearable
      >
        <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
      </el-input>
    </div>
    <p style="display:block;height:3vh;text-align:left;weight:2vw;margin-left:1vw;margin-bottom:1vh">{{cameraName}}</p>
    <div class="box-table">
      <el-table :data="listData" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
        <template slot="empty">
          <p>{{dataText}}</p>
        </template>
        <el-table-column label="序号" width="100">
          <template slot-scope="scope">
            <span>{{(currentPage-1)*pageSize + scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="预警图片">
          <template slot-scope="scope">
              <div>
                <el-image style="width:4vw;height:9vh;align-content: center;" v-if="scope.row.photoUrl!=''" :src="scope.row.photoUrl" :preview-src-list="[scope.row.photoUrl]"></el-image>
                    <div v-else style="width:4vw;height:9vh;background: #ddd;display: flex;align-items: center;justify-content: center;">暂无图片</div>
                   </div>
          </template> 
        </el-table-column>
          <el-table-column label="预警类型">
          <template slot-scope="scope">
            <span>{{scope.row.alarmEventName}}</span>
          </template> 
        </el-table-column>
        <el-table-column label="预警时间">
          <template slot-scope="scope">
            <span>{{scope.row.createDate}}</span>
          </template> 
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
    ></el-pagination>
  </div>
</template>

<script>
import base from '../../../untils/base'
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
  data(){
    return{
      search:{
        alarmEventName:'',
        camId:'',
        alarmDate:''
      },
      groupId:'',
      // camId:'',
      id:'',
      //列表
      listData:[],
      dataText:'数据加载中...',
      //分页
      currentPage:1,
      pageSize:10,
      totalItems:0,
      cameraName: ''

    }
  },
  mounted(){
    this.groupId = util.session.get('groupId')
    var params = this.$route.params
    this.search.camId = params.camId
    this.cameraName = params.name
    this.getData()
  },
  methods:{
    //查询
    doFilter(){
      this.currentPage = 1
      this.getData()
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //获取数据
    getData(){
      this.search.projectId = this.groupId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.getEquipCameraWaringPhoto(this.search).then(resp=>{
        console.log(resp);
        if(resp.data.code=='200'){
          var list = resp.data.data.pageInfo.list||[]
          this.totalItems = resp.data.data.pageInfo.total
          for (let i = 0; i < list.length; i++) {
            const element = list[i];
            element.photoUrl = base.httpCtx + element.photoUrl
          }
          this.listData = list
          if(list.length==0){
            this.dataText = '暂无数据'
          }
        }else{
          this.dataText = '暂无数据'
        }
      })
    },
    //返回
    goBack(){
      this.$router.go(-1)
    },
  }
}
</script>

<style scoped>
  .hua-box{
    width: 100%;
    height: 100%;
    position: relative;
    background: #fff;
  }
  .box-head{
    width: 100%;
    height: 6vh;
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    padding: 0 1vw;
  }
  .box-table{
    width: 100%;
    height: calc( 100% - 12vh );
    position: relative;
  }
</style>